module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-04-35-191_com.pinkcoffee.sexbattle.ff892fa3.jpg";